// import React from 'react';
// import { Row, Col, Card } from 'react-bootstrap';
// import { BaseData, Any, List, ModernFloatRangeExampleClass } from './BaseData.js';
// import { RenderControlData } from './RenderControlData.js';

// const Icon = ({ icon, alt = '' }) => {
//   if (React.isValidElement(icon)) {
//     return <span className="d-inline-flex align-items-center justify-content-center" style={{ width: 20, height: 20 }}>{icon}</span>;
//   }
//   if (typeof icon === 'string' && icon.length > 0) {
//     return <img src={icon} alt={alt} width={20} height={20} style={{ display: 'block' }} />;
//   }
//   return null;
// };

// const SocialCard = ({ icon, description, href }) => (
//   <Card
//     as="a"
//     href={href || '#'}
//     target="_blank"
//     rel="noopener noreferrer"
//     className="text-decoration-none border-0 shadow-sm"
//     style={{ minWidth: 14 }}
//   >
//     <Card.Body className="py-2 px-3 d-flex align-items-center">
//       <Icon icon={icon} alt={description} />
//       {/* <span className="ms-2">{description}</span> */}
//     </Card.Body>
//   </Card>
// );

// const SocialsBar = ({ items = [], label = 'contact:' }) => (
//   <div>
//      <Row xs={12} className="g-2">
//         {items.map((it, idx) => (
//           <Col key={idx}>
//             <SocialCard icon={it.icon} description={it.description} href={it.href} />
//           </Col>
//         ))}
//       </Row>
//     </div>
// );


// class SocialsBarData extends RenderControlData {
//   static annotations = Object.assign({}, RenderControlData.annotations, {
//     label: String,
//     items: List(Any),
//   });
// }

// export { SocialsBar, RenderControlData,SocialsBarData};
// export default SocialsBar;

// /**
//  * LLM EXAMPLE JSON (SocialsBar)
//  *
//  * {
//  *   "render_control_type": "socials_bar",
//  *   "label": "contact:",
//  *   "items": [
//  *     {
//  *       "icon": "/icons/x.svg",
//  *       "description": "X / Twitter",
//  *       "href": "https://x.com/your_handle"
//  *     },
//  *     {
//  *       "icon": "/icons/instagram.svg",
//  *       "description": "Instagram",
//  *       "href": "https://instagram.com/your_handle"
//  *     },
//  *     {
//  *       "icon": "/icons/youtube.svg",
//  *       "description": "YouTube",
//  *       "href": "https://youtube.com/@your_channel"
//  *     },
//  *     {
//  *       "icon": "/icons/linkedin.svg",
//  *       "description": "LinkedIn",
//  *       "href": "https://www.linkedin.com/in/your_profile/"
//  *     }
//  *   ]
//  * }
//  *
//  * Notes:
//  * - "render_control_type" must be "socials_bar" so the Section registry can route to SocialsBar.
//  * - "icon" should be a local image path or URL string (this component renders it as <img src="...">).
//  * - Each item must include "href" (target URL). "description" is used for alt text.
//  */


import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { BaseData, Any, List, ModernFloatRangeExampleClass } from './BaseData.js';
import { RenderControlData } from './RenderControlData.js';

/**
 * LLM EXAMPLE JSON (SocialsBar)
 * Kept as a real object (not a trailing comment) so defaults stay in sync,
 * but can be overridden per-prop when using <SocialsBar ... />.
 */
const SOCIALS_BAR_EXAMPLE = {
  render_control_type: "socials_bar",
  label: "contact:",
  items: [
    {
      icon: "/icons/x.svg",
      description: "X / Twitter",
      href: "https://x.com/your_handle"
    },
    {
      icon: "/icons/instagram.svg",
      description: "Instagram",
      href: "https://instagram.com/your_handle"
    },
    {
      icon: "/icons/youtube.svg",
      description: "YouTube",
      href: "https://youtube.com/@your_channel"
    },
    {
      icon: "/icons/linkedin.svg",
      description: "LinkedIn",
      href: "https://www.linkedin.com/in/your_profile/"
    }
  ]
};

const Icon = ({ icon, alt = '' }) => {
  if (React.isValidElement(icon)) {
    return <span className="d-inline-flex align-items-center justify-content-center" style={{ width: 20, height: 20 }}>{icon}</span>;
  }
  if (typeof icon === 'string' && icon.length > 0) {
    return <img src={icon} alt={alt} width={20} height={20} style={{ display: 'block' }} />;
  }
  return null;
};

const SocialCard = ({ icon, description, href }) => (
  <Card
    as="a"
    href={href || '#'}
    target="_blank"
    rel="noopener noreferrer"
    className="text-decoration-none border-0 shadow-sm"
    style={{ minWidth: 14 }}
  >
    <Card.Body className="py-2 px-3 d-flex align-items-center">
      <Icon icon={icon} alt={description} />
      {/* <span className="ms-2">{description}</span> */}
    </Card.Body>
  </Card>
);

const SocialsBar = ({ items = SOCIALS_BAR_EXAMPLE.items, label = SOCIALS_BAR_EXAMPLE.label }) => (
  <div>
    <Row xs={12} className="g-2">
      {items.map((it, idx) => (
        <Col key={idx}>
          <SocialCard icon={it.icon} description={it.description} href={it.href} />
        </Col>
      ))}
    </Row>
  </div>
);

class SocialsBarData extends RenderControlData {
  static annotations = Object.assign({}, RenderControlData.annotations, {
    label: String,
    items: List(Any),
  });
}

export { SocialsBar, RenderControlData, SocialsBarData };
export default SocialsBar;

/**
 * Notes:
 * - SOCIALS_BAR_EXAMPLE is the canonical example payload (and the component’s default values).
 * - Override any field by passing it as a prop to <SocialsBar />.
 * - "render_control_type" must be "socials_bar" so the Section registry can route to SocialsBar.
 * - "icon" should be a local image path or URL string (this component renders it as <img src="...">).
 * - Each item must include "href" (target URL). "description" is used for alt text.
 */
